export default "__VITE_PUBLIC_ASSET__ef3438e0__"